export default {
    issue_date: 'Дата выставления',
    name: 'Название',
    download: 'Скачать',
    download_button: 'Скачать',
    price: 'Цена',
    paid: 'Оплачено',
    rest_to_pay: 'Осталось оплатить:',
    paid_in_advance: 'Предоплата:',
    all_paid: 'Bсе оплачено',
}
